import { api } from "@/lib/api";

export type LeaveStatus = "REQUESTED" | "APPROVED" | "REJECTED" | "CANCELLED";
export type LeaveType =
  | "VACATION"
  | "SICKNESS"
  | "PERSONAL"
  | "PATERNITY"
  | "OTHER";

export type SickLeaveStatus = "active" | "closed" | "cancelled";
export type SickLeaveType =
  | "common_illness"
  | "non_work_accident"
  | "work_accident"
  | "occupational_disease"
  | "maternity"
  | "paternity"
  | "other";

export interface LeaveItem {
  id: string;
  start_date: string;
  end_date: string;
  days: number;
  type: LeaveType | string;
  status: LeaveStatus;
  reason: string | null;
  created_at: string | null;
  decided_at: string | null;
}

export interface SickLeaveItem {
  id: string;
  type: SickLeaveType | string;
  status: SickLeaveStatus;
  start_date: string;
  end_date: string | null;
  reason: string | null;
}

export interface LeavesDashboardData {
  year: number;
  tz_name: string;
  balance: {
    total_days: number;
    used_days: number;
    remaining_days: number;
  };
  leaves: LeaveItem[];
  sick_leaves: SickLeaveItem[];
}

export async function fetchLeavesDashboard(): Promise<LeavesDashboardData> {
  const { data } = await api.get<LeavesDashboardData>("/api/web/leaves/my");
  return data;
}

export interface LeaveCreateInput {
  type: LeaveType;
  start_date: string; // ISO YYYY-MM-DD
  end_date: string;
  reason?: string | null;
}

export async function createLeave(input: LeaveCreateInput): Promise<LeaveItem> {
  const { data } = await api.post<LeaveItem>("/api/web/leaves", input);
  return data;
}
